module.exports = __webpack_public_path__ + "media/images/favicon-10e5cf0b7cdb862f319a6ab217868733.ico";